// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const chartLineLegend = "LineChartLegend__chartLineLegend__X7+H- font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const line = "LineChartLegend__line__9iwMV";
export const solid = "LineChartLegend__solid__tXt9o";
export const dashed = "LineChartLegend__dashed__iyX95";
export const member = "LineChartLegend__member__WE4gN";
export const label = "LineChartLegend__label__kDcx4";
export const amount = "LineChartLegend__amount__71kja font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";